import { Role } from "@/constants/Role";

export const profileMixin = {
  data() {
    return {
      role: Role.USER,
      uid: '',
      isAdmin: false,
    }
  },
  mounted() {
    this.role = this.$store.getters['user/getUserRole'] || Role.USER;
    this.uid = this.$store.getters['user/getUserId'] || '';
    this.isAdmin = this.role === Role.ADMIN;
  },
}